import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles } from "@store/theme/mixins";
import { tableProps } from "@store/theme/props/table";
import { css } from "styled-components";

export interface StoreHistoryTableProps {
    container?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    reorderButton?: ButtonPresentationProps;
    reorderButtonSpinner?: LoadingSpinnerProps;
    countText?: TypographyPresentationProps;
    actionCell?: DataTableCellProps;
}

export const historyTableProps: StoreHistoryTableProps = {
    container: {
        ...tableProps.overflowWrapper,
        css: css`
            ${tableProps.overflowWrapper?.css}
            padding-bottom: ${TYPOGRAPHY.spacing.base};
        `,
    },
    centeringWrapper: {
        css: css`
            height: 150px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 0 1em;
        `,
    },
    noResultsText: {
        forwardAs: "p",
        variant: "h4",
    },
    reorderButton: {
        variant: "secondary",
    },
    reorderButtonSpinner: {
        size: 22,
        css: css`
            margin-left: auto;
            margin-right: auto;
            display: block;
        `,
    },
    countText: {
        forwardAs: "p",
        size: TYPOGRAPHY.size.base,
        css: css`
            ${contentSpacingStyles(null, ".5em")}
        `,
    },
    actionCell: {
        css: css`
            border-left: 1px solid ${getColor("common.border")};
        `,
    },
};
